import { ErrorBoundary } from 'react-error-boundary';

import dayjs from 'dayjs';

import useIsGroup from '@/utils/hooks/user/useIsGroup';

import { useDatepickerGlobalStore } from '@/utils/zustand/providers/datepicker-global-provider';

import { X } from '@/lib/socialProfile';

import AdsPermissionsBanner from '@/components/composite/Banners/AdsPermissionsBanner';
import { RestrictedNetworksWarningBanner } from '@/components/composite/Banners/RestrictedNetworksWarningBanner';
import { SocialProfilesGroupFirstStatsBanner } from '@/components/composite/Banners/SocialProfilesGroupFirstStatsBanner';
import { XDataAvailabilityContentBanner } from '@/components/composite/Banners/XDataAvailabilityContentBanner';
import ErrorAnalyticsFallback from '@/components/layouts/ErrorFallbacks/ErrorAnalyticsFallback';
import AnalyticsGrid from '@/components/layouts/wrappers/AnalyticsGrid';
import { AnalyticsWrapper } from '@/components/layouts/wrappers/AnalyticsWrapper';
import { NetworkTypeVisibilityGate } from '@/components/layouts/wrappers/NetworkTypeVisibilityGate';
import { StatsWrapper } from '@/components/pages/analyze/StatsWrapper';
import { StatsGroupWrapper } from '@/components/pages/analyze-group/StatsGroupWrapper';
import { PageContentWrapper } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper';
import { PageHeaderRecap } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap';

const ContentSocialProfileAnalytics = ({ config, periodSelected }) => {
    return (
        <>
            <div className="col-span-full">
                <AdsPermissionsBanner className="mb-10" />
            </div>
            <AnalyticsWrapper
                periodStart={periodSelected.start}
                periodEnd={periodSelected.end}
                compareTo={periodSelected.compareTo}
                period={periodSelected.period}>
                <StatsWrapper pageConfig={config} />
            </AnalyticsWrapper>
        </>
    );
};

const ContentGroupAnalytics = ({ config, periodSelected }) => {
    return (
        <>
            <div className="col-span-full mb-10">
                <SocialProfilesGroupFirstStatsBanner />
            </div>
            <div className="col-span-full mb-10">
                <RestrictedNetworksWarningBanner />
            </div>
            <ErrorBoundary FallbackComponent={ErrorAnalyticsFallback}>
                <AnalyticsGrid>
                    <StatsGroupWrapper pageConfig={config} periodSelected={periodSelected} />
                </AnalyticsGrid>
            </ErrorBoundary>
        </>
    );
};

export function LayoutAnalytics({ title, profileConfig, groupConfig }) {
    const isGroup = useIsGroup();

    const { date, period, compareTo } = useDatepickerGlobalStore((state) => state);
    const periodSelected = {
        date: [date.from, date.to],
        start: dayjs(date.from).format('YYYY-MM-DD'),
        end: dayjs(date.to).format('YYYY-MM-DD'),
        period,
        compareTo
    };

    const config = isGroup ? groupConfig : profileConfig;

    return (
        <>
            <PageHeaderRecap title={title} />
            <NetworkTypeVisibilityGate networks={[X]} className="mb-4">
                <XDataAvailabilityContentBanner />
            </NetworkTypeVisibilityGate>
            <PageContentWrapper>
                <div className="grid grid-cols-1 gap-x-3 md:grid-cols-[1fr_16.5rem]">
                    {isGroup ? (
                        <ContentGroupAnalytics config={config} periodSelected={periodSelected} />
                    ) : (
                        <ContentSocialProfileAnalytics
                            config={config}
                            periodSelected={periodSelected}
                        />
                    )}
                </div>
            </PageContentWrapper>
        </>
    );
}
